import type { TowerType } from "@mmotdg/shared";
import * as THREE from "three";
import { TOWER_COLORS } from "../towers/core.js";
import type { ProjectileModelView } from "./types.js";

export const PROJECTILE_HEIGHT = 0.5;

export function makeProjectileMaterial(type: TowerType, opts?: { emissive?: number; metalness?: number }): THREE.MeshStandardMaterial {
  const color = TOWER_COLORS[type] ?? 0xffd866;
  return new THREE.MeshStandardMaterial({
    color,
    emissive: opts?.emissive ?? color,
    emissiveIntensity: 0.6,
    metalness: opts?.metalness ?? 0.2,
    roughness: 0.4,
  });
}

export function wrapMesh(mesh: THREE.Mesh): ProjectileModelView {
  const group = new THREE.Group();
  group.add(mesh);
  return { group, mesh };
}
